// @flow

import { STATUS_LOADING, STATUS_SUCCESS, STATUS_FAILURE } from 'constants/statusConstants';
import React, { PureComponent } from 'react';
import ContentBloc from 'components/newsletter/blocs/ContentBloc';
import SidebarTab from 'components/sidebar/SidebarTab';
import { dynamicClassName } from 'utils/dynamicClassName';
import Loading from 'components/fragments/Loading';

type Props = {
  article?: boolean,
  status?: typeof STATUS_LOADING | typeof STATUS_SUCCESS | typeof STATUS_FAILURE,
  sidebarContent: Array<Object>
};

type ComponentState = {};

class Sidebar extends PureComponent<Props, ComponentState> {
  static defaultProps = {
    article: false,
    status: STATUS_SUCCESS,
    sidebarContent: SidebarTab
  };

  renderItems = () => {
    const { sidebarContent } = this.props;
    return sidebarContent.map<any>((blocFigure, index) => {
      return <ContentBloc key={index} {...blocFigure} />;
    });
  }

  renderLoader = () => <Loading />

  render() {
    const { article, status } = this.props;

    const asideClassName = dynamicClassName("sidebar");
    article && asideClassName.add('sidebar--article');

    return (
      <div className="col col-md-4 col-lg-3">
        <aside className={asideClassName.build()}>
          {status === STATUS_SUCCESS && this.renderItems()}
          {status !== STATUS_SUCCESS && this.renderLoader()}
        </aside>
      </div>
    );
  }
}
export default Sidebar;
